if (!customElements.get('short-bbd-bundle')) {
  customElements.define('short-bbd-bundle', class ShortBbdBundle extends HTMLElement {
    static SVG_NS = 'http://www.w3.org/2000/svg';
    static CLOCK_SVG_PATHS = [
      'M10 17.5C14.1421 17.5 17.5 14.1421 17.5 10C17.5 5.85786 14.1421 2.5 10 2.5C5.85786 2.5 2.5 5.85786 2.5 10C2.5 14.1421 5.85786 17.5 10 17.5Z',
      'M10 5.625V10H14.375'
    ];

    static buildClockIcon() {
      const svg = document.createElementNS(ShortBbdBundle.SVG_NS, 'svg');
      svg.setAttribute('class', 'icon icon-clock icon--medium');
      svg.setAttribute('viewBox', '0 0 20 20');
      svg.setAttribute('fill', 'none');
      ShortBbdBundle.CLOCK_SVG_PATHS.forEach((d) => {
        const path = document.createElementNS(ShortBbdBundle.SVG_NS, 'path');
        path.setAttribute('d', d);
        path.setAttribute('stroke', 'currentcolor');
        path.setAttribute('stroke-width', '1.5');
        path.setAttribute('stroke-linecap', 'round');
        path.setAttribute('stroke-linejoin', 'round');
        svg.appendChild(path);
      });
      return svg;
    }

    static formatBbd(value) {
      if (!value) return '';
      const isoMatch = String(value).match(/^(\d{4})-(\d{2})-(\d{2})/);
      if (isoMatch) {
        return `${isoMatch[3]}/${isoMatch[2]}/${isoMatch[1].slice(-2)}`;
      }
      const d = new Date(value);
      if (!isNaN(d.getTime())) {
        const yy = String(d.getFullYear()).slice(-2);
        const mm = String(d.getMonth() + 1).padStart(2, '0');
        const dd = String(d.getDate()).padStart(2, '0');
        return `${dd}/${mm}/${yy}`;
      }
      return String(value);
    }

    static appendTemplated(parent, template, replacements) {
      const tokens = Object.keys(replacements);
      if (!tokens.length) {
        parent.appendChild(document.createTextNode(template));
        return;
      }
      const regex = new RegExp(`(${tokens.join('|')})`);
      template.split(regex).forEach((part) => {
        if (!part) return;
        if (Object.prototype.hasOwnProperty.call(replacements, part)) {
          parent.appendChild(document.createTextNode(replacements[part]));
        } else {
          parent.appendChild(document.createTextNode(part));
        }
      });
    }

    constructor() {
      super();
      this._currentVariantId = null;
      this._unsubscribe = () => {};
      this._inflight = 0;
    }

    connectedCallback() {
      this._currentVariantId = this.dataset.variantId || null;
      this.replaceChildren();

      const events = window.FoxTheme && window.FoxTheme.pubsub && window.FoxTheme.pubsub.PUB_SUB_EVENTS;
      if (events && events.variantChange) {
        this._unsubscribe = window.FoxTheme.pubsub.subscribe(events.variantChange, ({data}) => {
          const newVariantId = data && data.variant && data.variant.id;
          if (newVariantId && String(newVariantId) !== String(this._currentVariantId)) {
            this._currentVariantId = String(newVariantId);
            this.refresh();
          }
        });
      }

      this.refresh();
    }

    disconnectedCallback() {
      try { this._unsubscribe(); } catch (e) {}
    }

    async refresh() {
      const variantId = this._currentVariantId;
      if (!variantId) return this.render([]);
      const client = window.FoxTheme && window.FoxTheme.storefrontClient;
      if (!client || typeof client.fetchBundleComponentsBbd !== 'function') return this.render([]);

      const ticket = ++this._inflight;
      const components = await client.fetchBundleComponentsBbd(variantId);
      if (ticket !== this._inflight) return;
      this.render(components);
    }

    render(components) {
      const wrapper = this.parentElement;
      this.replaceChildren();
      if (!components || !components.length) {
        if (wrapper) wrapper.classList.add('hidden');
        return;
      }

      const shortTemplate = this.dataset.shortLocaleTemplate || '__COMPONENT__';
      const extendedTemplate = this.dataset.extendedLocaleTemplate || '__COMPONENT__';
      const extendedFaqUrl = this.dataset.extendedFaqUrl || '';

      let rendered = 0;
      components.forEach(({name, shortBbd, extendedBbd}) => {
        const p = document.createElement('p');
        let span = document.createElement('span');

        if (shortBbd) {
          p.className = 'product__short-bbd-line flex items-center gap-2';
          p.appendChild(ShortBbdBundle.buildClockIcon());
          ShortBbdBundle.appendTemplated(span, shortTemplate, {
            __COMPONENT__: name,
            __DATE__: ShortBbdBundle.formatBbd(shortBbd),
          });
        } else if (extendedBbd) {
          p.className = 'product__short-bbd-line flex items-center gap-2';
          p.appendChild(ShortBbdBundle.buildClockIcon());
          if (extendedFaqUrl) {
            span = document.createElement('a');
            span.className = 'product__short-bbd-link';
            span.href = extendedFaqUrl;
          }
          ShortBbdBundle.appendTemplated(span, extendedTemplate, {
            __COMPONENT__: name,
            __DATE__: ShortBbdBundle.formatBbd(extendedBbd),
          });
        } else {
          return;
        }

        p.appendChild(span);
        this.appendChild(p);
        rendered += 1;
      });

      if (wrapper) wrapper.classList.toggle('hidden', rendered === 0);
    }
  });
}
